import React from "react";
import SignIn from "../../components/sign-in/sign-in";

const SignInandSignUpPage = () => (
<div className="sign-in-and-sign-up">
    <SignIn />  
</div>);

export default SignInandSignUpPage;
